/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:33:22
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-21 15:59:48
 */

export default {
  path: 'channel',
  component: () => import('@/pages/channel/ChannelList'),
  meta: {
    title: '渠道商户'
  },
  children: [{
      path: 'create',
      component: () => import('@/pages/common/CreateEdit'),
      meta: {
        title: '添加渠道商户'
      },
    },
    {
      path: ':channel_id/create',
      component: () => import('@/pages/common/CreateEdit'),
      meta: {
        title: ' 添加渠道子商户'
      },
    },
    {
      name: 'editChannel',
      path: ':channel_id/edit',
      component: () => import('@/pages/common/CreateEdit'),
      meta: {
        title: '编辑渠道商户'
      },
    },
  ]
}